import React from 'react';

interface IconBasketProps extends React.SVGProps<SVGSVGElement> {}

const IconBasket: React.FC<IconBasketProps> = (props) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.51538 6.78702L5.86859 3.87793H3.99805" stroke="white" stroke-width="1.09091"
                  stroke-linecap="round" stroke-linejoin="round"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M8.22423 14.7483L6.51562 6.78711H18.79C19.4077 6.78711 19.8674 7.35632 19.7384 7.96044L18.2819 14.7483C18.1859 15.1954 17.7913 15.5144 17.3336 15.5144H9.17163C8.7149 15.5144 8.32023 15.1954 8.22423 14.7483Z"
                  stroke="white" stroke-width="1.09091" stroke-linecap="round" stroke-linejoin="round"/>
            <path
                d="M17.6636 19.0304C17.4629 19.0304 17.2999 19.1933 17.3019 19.394C17.3019 19.5948 17.4648 19.7577 17.6655 19.7577C17.8662 19.7577 18.0292 19.5948 18.0292 19.394C18.0282 19.1933 17.8653 19.0304 17.6636 19.0304"
                stroke="white" stroke-width="1.09091" stroke-linecap="round" stroke-linejoin="round"/>
            <path
                d="M9.31543 19.0304C9.11471 19.0304 8.9518 19.1933 8.95374 19.394C8.95277 19.5948 9.11568 19.7577 9.3164 19.7577C9.51713 19.7577 9.68004 19.5948 9.68004 19.394C9.68004 19.1933 9.51713 19.0304 9.31543 19.0304"
                stroke="white" stroke-width="1.09091" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

    );
};

export default IconBasket;